import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "停用",
    modelValue: _ctx.disabledVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.disabledVisible) = $event)),
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    "custom-class": "dialog-width-small",
    center: "",
    top: "5vh",
    onClose: _ctx.handleDisClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          size: "default",
          onClick: _ctx.handleDisClose
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 取 消 ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "default",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleDisSave(_ctx.accountAppItem.id)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确 定 ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style['title'])
      }, "是否确认停用 [" + _toDisplayString(_ctx.accountAppItem.appName + ' 编码' + _ctx.accountAppItem.appCode) + "] 的应用？", 3),
      _createVNode(_component_el_form, {
        inline: false,
        "label-width": "80px",
        rules: _ctx.rules,
        model: _ctx.formData,
        ref: "disabledForm",
        size: "default"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "备注",
            prop: "remark"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "textarea",
                maxlength: "100",
                modelValue: _ctx.formData.remark,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.remark) = $event)),
                modelModifiers: { trim: true },
                placeholder: "请输入备注信息，限100字符"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["modelValue", "onClose"]))
}